import { ff } from '@atlassian/jira-feature-flagging';

export const isDescriptiveLabelEnabled = () =>
	ff('jsw.roadmaps.deployment-issue-sideview-identical-and-non-descriptive-label_9xw1u');
